import axios, {AxiosError, CreateAxiosDefaults} from 'axios'
import LocalStorageResolver from '@/services/localStorageResolver'

const jwt = LocalStorageResolver.getJwt

const configAxios: CreateAxiosDefaults = {
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    Authorization: `Bearer ${jwt}`,
  },
}

const fileHttpClient = axios.create(configAxios)

fileHttpClient.interceptors.request.use(
  (config) => {
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

fileHttpClient.interceptors.response.use(
  (response) => {
    return response
  },
  async (error: AxiosError) => {
    if (error.response) {
      return Promise.reject(error)
    }
  }
)

export default fileHttpClient
